<template>
    <div class="sc-detail-body">
        <div v-if="sections.length === 0" class="sc-empty">
            <span>{{ $t("지정된 제어 대상이 없습니다.") }}</span>
        </div>

        <div v-for="section in sections" :key="section.equipType" class="sc-target-group">
            <h4>
                {{ section.name }}
                <span class="sc-pill">{{ section.groups.length + section.equips.length }}</span>
            </h4>
            <div v-if="!section.groups.length && !section.equips.length" class="sc-meta">
                {{ $t("선택된 그룹/설비가 없습니다.") }}
            </div>
            <div v-else class="sc-target-grid">
                <div v-for="group in section.groups" :key="`g${group.sysNodeIdx}`" class="sc-target-chip">
                    <span class="sc-kind-badge is-group">{{ $t("그룹") }}</span>
                    <span class="n" :title="group.sysNodeName">{{ group.sysNodeName || `#${group.sysNodeIdx}` }}</span>
                </div>
                <div v-for="equip in section.equips" :key="`e${equip.equipIdx}`" class="sc-target-chip">
                    <span class="sc-kind-badge">{{ $t("설비") }}</span>
                    <span class="n" :title="equip.equipName">{{ equip.equipName || `#${equip.equipIdx}` }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { equipTypeName } from "../../utils/scheduleFormat";

export default {
    props: {
        detail: { type: Object, required: true },
    },
    computed: {
        sections() {
            return (this.detail.targets || []).map((target) => ({
                equipType: target.equipType,
                name: equipTypeName(this.$store, target.equipType),
                groups: (this.detail.groups || []).filter((g) => g.equipType == target.equipType),
                equips: (this.detail.equips || []).filter((e) => e.equipType == target.equipType),
            }));
        },
    },
};
</script>
